<template>
    <v-card class="pa-0 search-filters search-filters-desktop" flat>
        <v-card-title class="search-filters-title title">{{'Filters' | translation}}</v-card-title>

        <v-card-text class="pa-0">
            <categories-filter
                :parentsList="searchResults.parentsList"
                :categories="searchResults.categories"
                :categoriesFacet="searchResults.categoriesFacet"
            ></categories-filter>

            <price-filter class="bordered-filter"></price-filter>

            <search-filters
                :search-results="searchResults"
            ></search-filters>
        </v-card-text>
    </v-card>
</template>

<style>
    .search-filters-desktop .bordered-filter {
        border-bottom: 1px solid #d1d1d1;
        border-left: 1px solid #d1d1d1;
        border-right: 1px solid #d1d1d1;
        border-top: none !important;
        border-color: #d1d1d1 !important;
    }
</style>

<script>
    import CategoriesFilter from './CategoriesFilter';
    import SearchFilters from './SearchFilters';
    import PriceFilter from './PriceFilter';

    export default {
        name: 'DesktopFilters',
        components: {
            CategoriesFilter,
            SearchFilters,
            PriceFilter,
        },
        props: [
            'searchResults',
        ],
    };
</script>